import * as React from 'react';
import { Site, Brand, Group } from '../../../../client-management/entities';
import { defaultSftpUser, ISftpUser } from '../data/NewSftpUserConstants';
import { IValue as ImportedValue, NewSftpUserProvider } from './newSftpUserProvider';
import { ActionTypes, newSftpUserReducer } from './newSftpUserReducer';

export type IValue = ImportedValue;

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export type Dispatch = (action: IAction) => void;

export interface IState {
  sftpUser: ISftpUser;
  stepValid: boolean;
  validSteps: number[];
  sites: Site[];
  brands: Brand[];
  groups: Group[];
  createdSftpUser?: ISftpUser;
  success?: boolean;
  error?: boolean;
  errorMessage?: string;
}

export const defaultContextValues: IState = {
  stepValid: false,
  validSteps: [],
  sftpUser: defaultSftpUser,
  sites: [],
  brands: [],
  groups: [],
  success: false,
};

export const NewSftpUserStateContext = React.createContext<IState | undefined>(undefined);
export const NewSftpUserDispatchContext = React.createContext<Dispatch | undefined>(undefined);

function useNewSftpUserState() {
  const context = React.useContext(NewSftpUserStateContext);
  if (context === undefined) {
    throw new Error('useNewSftpUserState must be used within a NewSftpUserProvider');
  }
  return context;
}

function useNewSftpUserDispatch() {
  const context = React.useContext(NewSftpUserDispatchContext);
  if (context === undefined) {
    throw new Error('useNewSftpUserDispatch must be used within a NewSftpUserProvider');
  }
  return context;
}

export { NewSftpUserProvider, newSftpUserReducer, useNewSftpUserState, useNewSftpUserDispatch };
